exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.never-wrap[data-v-f86630f0] {\n    white-space: nowrap;\n}\n", ""]);

// exports
